import { BrandfolderHexColors, ButtonLooks, StandardButton } from '@brandfolder/react';
import { FunctionComponent, HTMLAttributes } from 'react';
import styled from 'styled-components';

import { addClassNames } from '@styles/classnames';

interface FormFooterProps extends HTMLAttributes<HTMLDivElement> {
  isDirty: boolean;
  loading: boolean;
  onCancel: (show: boolean) => void;
  saveButtonText?: string;
}

const UnstyledFormFooter: FunctionComponent<FormFooterProps> = (props) => {
  const { isDirty, loading, onCancel, saveButtonText, ...otherProps } = props;

  return (
    <footer {...otherProps} className={addClassNames(['form-footer'], otherProps?.className)}>
      <StandardButton
        disabled={loading}
        look={ButtonLooks.Tertiary}
        onClick={(): void => {
          onCancel(false);
        }}
      >
        Cancel
      </StandardButton>
      <StandardButton disabled={!isDirty} loading={loading} type="submit">
        {saveButtonText ?? (loading ? 'Saving...' : 'Save')}
      </StandardButton>
    </footer>
  );
};

const StyledFormFooter = styled(UnstyledFormFooter)`
  background-color: ${BrandfolderHexColors.DirtyMarshmallow};
  display: flex;
  gap: 20px;
  justify-content: flex-end;
  padding: 20px;
`;

export const FormFooter: FunctionComponent<FormFooterProps> = (props) => {
  return <StyledFormFooter {...props} />;
};
